import React from 'react'
import Link from 'gatsby-link'
import arrowUrl, { ReactComponent as Arrow } from '../../assets/svg/icon-arrow-right.svg'

const ThemeItem = ( props ) => (
  <li>
    <Link exact to={ props.node.path } onClick={ props.onClick } className={ props.linkClassName } activeClassName={ props.activeClassName }>
      <span>
        { props.node.title }{ props.includeArrows === true ? '\u00A0' : null }{ props.includeArrows === true ? <Arrow /> : null }
      </span>
    </Link>
  </li>
)

const ThemeList = ( props ) => (
  <ul className={ props.className }>
    { props.themes.map((node) =>
      <ThemeItem 
        node={node.node}  
        key={node.node.theme_id}
        onClick={ props.onLinkClick }
        includeArrows={ props.includeArrows }
        linkClassName={ props.linkClassName }
        activeClassName={ props.activeClassName } />
    )}
  </ul>
)

export default ThemeList


// WEBPACK FOOTER //
// ./src/components/ThemeList/ThemeList.js